<div class="toolbar" style="margin: 0.5rem;">
  <button
    style="margin-right: 0.5rem;"
    nz-button
    nzType="dashed"
    (click)="exportPdf()">
    Xuất PDF
  </button>

  <button
    nz-button
    nzType="dashed"
    onclick="window.print()">
    In phiếu
  </button>
</div>


<div *ngFor="let data of datas">
  <div id="{{'print-div-' + data.orderDetail.id}}" class="print-wrapper">
    <img
  *ngIf="lstConfigPrintOrder.backgroundLogo"
  class="logo-background"
  [src]="data.urlBackground"
  />
  <div class="print-header">
    <table border="0" width="100%" style="margin-bottom: 2rem">
      <tr>
        <td class="logo">
          <img
          *ngIf="lstConfigPrintOrder.logo && data.urlHeader"
          style="height: 120px; margin: auto; display: block"
          [src]="data.urlHeader"
          />
        </td>
        <td class="content-header">
          <h1 style="text-align: center">Phòng xét nghiệm Invivolab</h1>
          <div style="text-align: center">
            <p>Địa chỉ: 257B1 Giải Phóng, Phương Mai, Đống Đa, TP Hà Nội</p>
          </div>
          <div class="row-info flex-item">
            <div class="col-5">
            Email:<a href="info@invivolab.vn" class="link-info">
              info@invivolab.vn</a
              >
            </div>
            <div class="hoz-divider col-2">|</div>
            <div class="col-5">
              Website:<a href="invivolab.vn" class="link-info"> invivolab.vn</a>
            </div>
            <!-- <table border="0" width="100%" style="margin-bottom: 2rem">
              <tr>
                <td>Email:<a href="info@invivolab.vn" class="link-info">
                  info@invivolab.vn</a></td>
                <td>
                  <span class="hoz-divider col-2">|</span>
                </td>
                <td>
                  Website:<a href="invivolab.vn" class="link-info"> invivolab.vn</a>
                </td>
              </tr>
            </table> -->
          </div>
        </td>
      </tr>
    </table>
    <div class="flex-item" style="font-family: serif; display: flex">
      <h2 class="col-9" style="text-align: center; text-transform: uppercase; flex-grow: 1">
        Phiếu trả kết quả xét nghiệm
      </h2>
      <div class="col-3">
        <ngx-barcode
        [bc-font-size]="9"
        [bc-margin]="1"
        [bc-width]="2"
        [bc-height]="45"
        [bc-font]=""
        [bc-value]="data.barcode"
        bc-element-type="svg"
        [bc-display-value]="true"
        [bc-margin-top]="1"
        [bc-margin-bottom]="1"
        [bc-margin-left]="1"
        [bc-margin-right]="1"
        ></ngx-barcode>
      </div>
    </div>
      <table border="0" width="80%" class="info">
        <tr>
          <td>Họ và tên:</td>
          <td style="text-transform: uppercase; font-weight: bold">
            {{ data.orderDetail.patient.name }}
          </td>
          <td>Năm sinh: {{ data.orderDetail.patient.dob | dateFormat: "yyyy" }}</td>
          <td>Giới tính: {{ data.orderDetail.patient.sex === 0 ? "Nữ" : "Nam" }}</td>
        </tr>
        <tr>
          <td>Địa chỉ:</td>
          <td colspan="2">{{ data.orderDetail.patient.address }}</td>
          <td>Số điện thoại: {{ data.orderDetail.patient.phone }}</td>
          <td></td>
        </tr>
        <tr>
          <td *ngIf="lstConfigPrintOrder.doctor">Bác sỹ chỉ định:</td>
          <td *ngIf="lstConfigPrintOrder.doctor" colspan="2">
            {{ data.orderDetail.orderDoctor }}
          </td>
          <td>Đơn vị:</td>
          <td></td>
        </tr>
        <tr>
          <td>Chẩn đoán:</td>
          <td colspan="2">{{ data.orderDetail.chanDoan }}</td>
          <td>Ghi chú: {{ data.orderDetail.note }}</td>
          <td></td>
        </tr>
      </table>
      <table border="0" width="100%" class="info">
        <tr>
          <td>
            TG lấy mẫu:
            {{
            data.resultValues.specimenInfos[0]?.dateTaken | date: "hh:mm"
            }}
          </td>
          <td>Loại mẫu: {{ data.resultValues.specimenType }}</td>
          <td>
            Ngày lấy mẫu:
            {{
              data.resultValues.specimenInfos[0]?.dateTaken | date: "dd/MM/yyyy"
            }}
          </td>
        </tr>
        <tr>
          <td>
            TG nhận mẫu:
            {{
              data.resultValues.dateReceived == null ? "" : data.resultValues.dateReceived | date: "hh:mm"
            }}
          </td>
          <td>Tình trạng mẫu: Đạt</td>
          <td>
            Ngày nhận mẫu:
            {{
              data.resultValues.dateReceived == null ? "" : data.resultValues.dateReceived
              | date: "dd/MM/yyyy"
            }}
          </td>
        </tr>
      </table>
      <br />
      <table style="border-collapse: collapse;" width="100%" class="table-result">
        <thead>
          <tr>
            <th width="30%">Xét nghiệm</th>
            <th>Kết quả</th>
            <th width="90px">Đơn vị</th>
            <th width="140px">Giá trị tham chiếu</th>
            <th width="100px">Ghi chú</th>
            <th width="140px">Máy XN/PP XN</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let group of data.groupResultValues">
            <tr>
              <td
              colspan="6"
              style="font-weight: bold; text-decoration: underline"
                >
                {{ group.name.toUpperCase() }}
              </td>
            </tr>
            <ng-container *ngFor="let item of group.items">
              <tr [class]="toTdCls(item)">
                <td>{{ item.resultType.name }}</td>
                <td class="color-change">{{ item.valueStr }}</td>
                <td>{{ item.resultType.unitName }}</td>
                <td>
                  <div *ngIf="item.resultType && item.resultType.unitType === 0">
                    {{ item.resultType.normalMin }} -
                    {{ item.resultType.normalMax }}
                  </div>
                </td>
                <td></td>
                <td>
                  {{ item.machineName }}
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
      <div class="info-contact">
        <p>
          Xin trân trọng cảm ơn Quý khách đã sử dụng dịch vụ y tế của chúng tôi!
        </p>
        <p>
          Mọi thông tin liên quan đến dịch vụ xét nghiệm của Invivo Lab, Quý khách
          vui lòng liên hệ: 0928 257257
        </p>
      </div>
      <div class="sign flex-item">
        <!-- <table border="0" width="100%">
          <tr>
            <td *ngIf="lstConfigPrintOrder.conductor" style="text-transform: uppercase; font-weight: bold">Người thực hiện</td>
            <td *ngIf="lstConfigPrintOrder.responsible" style="text-transform: uppercase; font-weight: bold">Phụ trách chuyên môn</td>
            <td *ngIf="lstConfigPrintOrder.professionalCouncil" style="text-transform: uppercase; font-weight: bold">Hội đồng chuyên môn</td>
          </tr>
        </table> -->
        <div *ngIf="lstConfigPrintOrder.conductor">Người thực hiện</div>
        <div *ngIf="lstConfigPrintOrder.responsible">Phụ trách chuyên môn</div>
        <div *ngIf="lstConfigPrintOrder.professionalCouncil">
          Hội đồng chuyên môn
        </div>
      </div>
      <div class="content-footer">
        <div>
          Thời gian trả KQ:
          {{
            data.resultValues.data[0]?.value.testedDate | date: "hh:mm dd/MM/yyyy"
          }}
        </div>
        <div>
          <p>
            *: Xét nghiệm đã được công nhận theo ISO 15189:2012,
            <br />**: XN thực hiện theo PXN chuyển gửi, <br />Các giá trị in đậm
            là giá trị nằm ngoài khoảng tham chiếu, <br />Các kết quả XN chỉ có
            giá trị đối với mẫu đã nhận.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="pagebreak"> </div>
</div>
